import React from 'react'
import { makeStyles } from 'transfix-ui/core'
import { Maybe } from 'types/graphqlTypes'
import { CheckFilledIcon, ClockIcon, RejectedFilledIcon } from 'transfix-icons'
import { Tooltip } from 'transfix-ui'

export const useApprovalIconStyles = makeStyles(theme => ({
  icon: {
    marginLeft: theme.spacing(1),
  },
}))

export interface IShipperApprovalIconProps {
  approvalState: Maybe<String>
  id: string
}

export const ShipperApprovalIcon = React.memo<IShipperApprovalIconProps>(
  ({ approvalState, id }) => {
    const classes = useApprovalIconStyles()

    if (approvalState === 'rejected') {
      return (
        <Tooltip
          position='bottom'
          id={id}
          trigger={
            <span>
              <RejectedFilledIcon size='large' color='badgeRed' className={classes.icon} />
            </span>
          }>
          Shipper {approvalState}
        </Tooltip>
      )
    }
    if (approvalState === 'approved') {
      return <CheckFilledIcon size='large' color='green3' className={classes.icon} />
    }

    return (
      <Tooltip
        position='bottom'
        id={id}
        trigger={
          <span>
            <ClockIcon size='large' color='warning' className={classes.icon} />
          </span>
        }>
        Shipper {approvalState}
      </Tooltip>
    )
  }
)
